var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-tab"},[_vm._l((_vm.list),function(item){return [_c('span',{staticClass:"tab-item"},[_c('router-link',{staticClass:"list",attrs:{"to":item.to}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(item.name)))]),_vm._v(" "),(item.num)?_c('span',{staticClass:"num"},[_vm._v(_vm._s(item.num))]):_vm._e()])],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40dd1b08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav/TopNav.vue
// module id = y1Wf
// module chunks = 1